import { LoadingSpinner, ScrollArea } from '@app/shared/ui/atoms/Common';
import { TopSection, List } from '@app/shared/ui/organisms/Roadmap';
import { usePreloadImages } from '@app/shared/hooks/usePreloadImages';
import { ROADMAP_PRELOAD_IMAGES } from '@app/assets';

export default function RoadmapPage() {
  const isImagesLoading = usePreloadImages(ROADMAP_PRELOAD_IMAGES);

  if (isImagesLoading) {
    return <LoadingSpinner />;
  }

  return (
    <ScrollArea>
      <TopSection />
      <List />
    </ScrollArea>
  );
}
